import { FormControl } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../services/api";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
}));

const filterOptions = createFilterOptions({
  trim: true,
});

const AutoCompleteCliente = ({ clientesSelecionados, onChange }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [textoPesquisaPessoa, setTextoPesquisaPessoa] = useState("");
  const [contatoClienteSelecionado, setContatoClienteSelecionado] =
    useState(null);

  const handleChange = (newValue) => {
    onChange(newValue ?? null);
  };

  useEffect(() => {
    const carregarContato = async () => {
      setContatoClienteSelecionado(
        clientesSelecionados &&
          clientesSelecionados.length > 0 &&
          clientesSelecionados[0].pessoa
          ? clientesSelecionados[0].pessoa
          : { id: null, nomeFantasia: "", nomeRazaoSocial: "" }
      );
    };
    carregarContato();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientesSelecionados]);

  useEffect(() => {
    if (textoPesquisaPessoa.length < 1) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchUsers = async () => {
        try {
          const { data } = await api.get("/autocompletetag-pessoa/", {
            params: { texto: textoPesquisaPessoa },
          });
          setOptions(data.pessoas);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toast.error(err.response.data.error);
        }
      };

      fetchUsers();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [textoPesquisaPessoa]);

  return (
    <div style={{ marginTop: 6 }}>
      <FormControl fullWidth margin="dense" variant="outlined">
        <Autocomplete
          style={{ width: "100%", marginBottom: 20 }}
          getOptionLabel={(option) =>
            `${
              option.nomeFantasia ||
              option.nomeRazaoSocial ||
              contatoClienteSelecionado.nomeFantasia ||
              contatoClienteSelecionado.nomeRazaoSocial
            }`
          }
          onChange={(e, newValue) => {
            setContatoClienteSelecionado(newValue);
            handleChange(newValue);
          }}
          id="contatoClienteSelecionado"
          name="contatoClienteSelecionado"
          value={contatoClienteSelecionado}
          options={options}
          filterOptions={filterOptions}
          freeSolo
          autoHighlight
          noOptionsText="Nenhuma opção encontrada..."
          loading={loading}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Digite para buscar um cliente"
              variant="outlined"
              onChange={(e) => setTextoPesquisaPessoa(e.target.value)}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      </FormControl>
    </div>
  );
};

export default AutoCompleteCliente;
